<template>
    <span>
        <kb-button hideBorder=true size='sm' class='small-bottom-margin' variant='outline-secondary' @click='copyCurrentUrl'><span class="glyphicon glyphicon-share"></span> Share</kb-button>
        <kb-modal auto-focus-button='ok' ref='urlCopiedModalRef' :title='"Page Link Copied"' ok-only @ok='handleModalOk' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                A link to this page has been copied for pasting into email or websites to share with others!
            </div>
        </kb-modal>
    </span>
</template>

<script>

export default {
    methods: {
        copyCurrentUrl() {
            let dummy = document.createElement('input')
            let text = window.location.href

            document.body.appendChild(dummy)
            dummy.value = text
            dummy.select()
            dummy.setSelectionRange(0, 99999) // For mobile devices
            document.execCommand('copy')
            document.body.removeChild(dummy)

            this.$refs.urlCopiedModalRef.show()
        },
        handleModalOk() {
            this.$refs.urlCopiedModalRef.hide()
        }
    }
}
</script>

<style scoped>
</style>
